import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import frJson from "globals/langs/fr.json";
import enJson from "globals/langs/en.json";
import { LANGS } from "globals/constants.ts";
import dayjs from "dayjs";
import ajax from "config/ajax.ts";
import { EnumLangType } from "globals/types/globals.ts";


const STORAGE_KEY = "bethere-lang";

const missingKeysSend: string [] = [];

i18n
  .use(initReactI18next)
  .init({
    lng: "en",//default lang
    debug: process.env.NODE_ENV !== "production",
    fallbackLng: false,//dont fallback to any lang, if key dont exist
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    resources: {
      fr: {
        translation: frJson
      },
      en: {
        translation: enJson
      }
    },
    parseMissingKeyHandler(key: string, defaultValue?: string): any {
      //dont send same key twice
      if (missingKeysSend.includes(key)) {
        return defaultValue;
      }
      missingKeysSend.push(key);
      const err = new Error(`Missing translations key: ${key}`);
      if (window.Sentry) {
        window.Sentry.captureException(err);
      }
      return defaultValue;
    }
  });

export const selectLang = (lang: EnumLangType) => {
  i18n.changeLanguage(lang);
  ajax.defaults.headers.common["Accept-Language"] = lang;
  ajax.defaults.headers.common["x-locale"] = lang;
  window.localStorage.setItem(STORAGE_KEY, lang);
  dayjs.locale(`${lang}-ca`);
  document.querySelector("html")?.setAttribute("lang", lang);
  document.querySelector("meta[property=\"og:locale\"]")?.setAttribute("content", `${lang}_CA`);
  return lang;
};

export function getCurrentLang(): EnumLangType {
  return i18n.language as EnumLangType;
}

let localStorageValue: EnumLangType | null = null;
let browserDetectionValue: EnumLangType | null = null;

try {
  const lang = window.localStorage.getItem(STORAGE_KEY);
  if (lang && Object.values(LANGS).includes(lang)) {
    localStorageValue = lang as EnumLangType;
  }
} catch (e) {
  // @ts-ignore
}


if (typeof navigator !== "undefined") {
  let browserLangs: string[] = [];
  if (typeof navigator.languages !== "undefined" && navigator.languages) {
    // chrome only; not an array, so can't use .push.apply instead of iterating
    for (const lang of navigator.languages) {
      browserLangs.push(lang);
    }
  }

  // @ts-ignore
  if (typeof navigator.userLanguage !== "undefined" && navigator.userLanguage) {
    // @ts-ignore
    browserLangs.push(navigator.userLanguage);
  }
  if (typeof navigator.language !== "undefined" && navigator.language) {
    browserLangs.push(navigator.language);
  }

  if (browserLangs) {
    if (!Array.isArray(browserLangs)) {
      browserLangs = [browserLangs];
    }
    const firstLang = browserLangs[0].split("-")[0].toLowerCase();//remove country so fr-CA fo to fr
    //make sure its a valid lang
    if (firstLang && Object.values(LANGS).includes(firstLang)) {
      browserDetectionValue = firstLang as EnumLangType;//set
    }
  }
}

//select localstorage lang if exist
if (localStorageValue) {
  selectLang(localStorageValue);
} else if (browserDetectionValue) {
  //or select from browser
  selectLang(browserDetectionValue);
} else {
  //default to EN
  selectLang(LANGS.EN);
}
